import { IntlShape } from 'react-intl';

export const formatTimeLength = (rawLength: number, intl: IntlShape): string => {
  if (rawLength < 60)
    return intl.formatMessage({ id: 'time.shortenedSecond' }, { seconds: Math.floor(rawLength) });

  if (rawLength < 3600)
    return intl.formatMessage(
      { id: 'time.shortenedMinute' },
      { minutes: Math.floor(rawLength / 60) },
    );

  return intl.formatMessage({ id: 'time.shortenedHour' }, { hours: Math.floor(rawLength / 3600) });
};
